module.exports = __webpack_public_path__ + "static/img/mobile_pg_top.78681956.png";